import { createFileRoute } from '@tanstack/react-router';

import { PlanFundsTab } from '../../../../../components';

const Page = () => {
  const params = Route.useParams();
  return <PlanFundsTab planId={params.planId} />;
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/plans/$planId/funds'
)({
  component: Page
});
